module.exports = "<div class=\"alert alert-danger\">\n  <div>שגיאה {{ errorCode }}</div>\n  <div>הודעה {{ errorMessage }}</div>\n</div>\n\n<div class=\"row\">\n  <div class=\"col-md-12 okdiv\">\n    <button class=\"round okbutton\" [routerLink]=\"['/']\">עמוד הראשי</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/notok.component.html
// module id = ./src/app/payment/notok.component.html
// module chunks = main